module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUBJREFUOE+tlK9Ow2AQwH83NgPJECBAggAzGGZmAs0rlAfAQHiAPQAewgwPwN4DgcEwGAIDYgLDBEuG6eiR77aWtusKIb3k0vTu66/357sTMkQvWYGpCst2RPkABk7lxJ4JkfibHlFhhzol1rN+ENkC3nikK1f4oS0C6QVVSjQQFnMhoVP5JOBOThk6k4Eskl32/wyJwx64cZFNQG0awFoq6RqKh7JpduEFoYPSS0Xcl2PuxQorNFNOD8HLTFHpgOmPKLcOtIWwHVmFGnD2S51aiciUZ9FzmpSt1RMRgzhYnvRQWtGBMQPRNgdAJfZVB2EpFxMwSqXu/w+kjCBRQ7/A1AordlHtz72QcIiyMe3mK3A990IWOiIGK2Jooxl0w1tnb2buZi9Vny5PmWskMTrhYvtilTJV840ZssD7vMX2DeuBfx3HpBeYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/board_pot.png
// module id = cbSQ
// module chunks = 1